@if (data) {
  <div>
    <label>{{title}}</label>
    <mat-slider min="{{data.min}}" max="{{data.max}}" discrete>
      <input #startThumb value="{{_start}}" (valueChange)="updateStart($event, startThumb)" matSliderStartThumb>
      <input #endThumb value="{{_end}}" (valueChange)="updateEnd($event, endThumb)" matSliderEndThumb>
    </mat-slider>
  </div>
}
